import React from "react";
import { Dispatch } from "redux";
import { connect } from "react-redux";
import { useAuth0 } from "@auth0/auth0-react";
import { Grid, Typography } from "@material-ui/core";
import { Player } from "../../../store/players/models";
import { RegisterToTournament } from "../../../store/tournaments/models";
import { AppState } from "../../../store/reducer";
import { State as RegistrationState } from "../../../store/registration/reducer";
import { registerToTournament } from "../../../store/tournaments/actions";

interface TournamentRegistrationProgressProps {
    startRegistration: (target: RegisterToTournament, playerData: Player, token: string) => void;
    registration: RegistrationState;
}

const TournamentRegistrationProgress: React.FC<TournamentRegistrationProgressProps> = ({registration, startRegistration}) => {

    const { getAccessTokenSilently } = useAuth0();

    React.useEffect(() => {
        getAccessTokenSilently().then(token => {
            startRegistration(
                registration.tournamentSelection, 
                registration.updatedPlayer!,
                token);
        }).catch((reason: any) => {
            console.log(reason);
        })

    }, []);

    return <>
        <Grid container style={{minHeight: '200px'}} alignItems="center" justify="center">
            <Grid item>
                <Typography variant="h5" color="primary">
                    {registration.registrationMessage}
                </Typography>
            </Grid>
        </Grid>
    </>

};

const mapStateToProps = (state: AppState) => ({
    registration : state.registration
});

const mapDispatchToProps = (dispatch: Dispatch) => ({
    startRegistration: (target: RegisterToTournament, playerData: Player, token: string) => dispatch(registerToTournament({
        target,
        playerData,
        token
    }))
});

export default connect(mapStateToProps, mapDispatchToProps)(TournamentRegistrationProgress);